import { Component, computed, input, ChangeDetectionStrategy } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { LorenAsset } from "../../../loren-assets/interfaces/loren-asset.interface";
import { LorenMeteringType } from "../../../loren-assets/interfaces/loren-metering-type";
import { LorenMetering } from "../../../loren-assets/interfaces/loren-metering.interface";
import { LorenAssetDetailsAnalysisItemComponent } from "../loren-asset-details-analysis-item/loren-asset-details-analysis-item.component";

@Component({
  selector: "loren-loren-asset-details-analysis",
  imports: [TranslocoPipe, LorenAssetDetailsAnalysisItemComponent],
  templateUrl: "./loren-asset-details-analysis.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./loren-asset-details-analysis.component.scss",
})
export class LorenAssetDetailsAnalysisComponent {
  readonly relevantMeteringTypes = [
    LorenMeteringType.TEMPERATURE_SENSOR,
    LorenMeteringType.HUMIDITY_SENSOR,
    LorenMeteringType.CO2_SENSOR,
  ];
  asset = input<LorenAsset>();

  meterings = computed<LorenMetering[]>(() =>
    this.asset().metering.filter((m) =>
      this.relevantMeteringTypes.some((t) => m.type === t)
    )
  );
}
